// Terror
export const arrayFirstList = [
  {
    id: 1,
    url: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRFO7Tv5Ahlh95y7329wyWIjjrZr2uMMhG2gQ&s",
  },
  {
    id: 2,
    url: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQosOuVPi9RJgc3cHQLV-HAT2ez5opUH1IyZg&s",
  },
  {
    id: 3,
    url: "https://hips.hearstapps.com/es.h-cdn.co/fotoes/images/cinefilia/mejores-posters-cine-terror-miedo/mv5bntc4odm2mtu2nf5bml5banbnxkftztgwntezntmynje-._v1_sy1000_cr0-0-647-1000_al_/137670471-1-esl-ES/MV5BNTc4ODM2MTU2NF5BMl5BanBnXkFtZTgwNTEzNTMyNjE-._V1_SY1000_CR0-0-647-1000_AL_.jpg?resize=980:",
  },
  {
    id: 4,
    url: "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEiM_jVG7c9A1gHbFI2k06PpBEWK4Kzk5EIUF0XYDT1T3a6d1PfywW7wDLMilVA5i0SfHY57cvuKpc-akvNIs1SgOLeTVfphqkqIMR1Ogw9HTf24eOsSf-st7wNs1x9i7kSSIc6uSievdj4/s1600/Annabelle-2014-Movie-Poster-750x1111.jpg",
  },
  {
    id: 5,
    url: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRgszNIDDvF46u3g2cStNEDlgNqrhbCGPXfww&s",
  },
];

// Ciencia ficción
export const arraySecondList = [
  {
    id: 1,
    url: "https://upload.wikimedia.org/wikipedia/en/b/bc/Interstellar_film_poster.jpg", // Interstellar
  },
  {
    id: 2,
    url: "https://upload.wikimedia.org/wikipedia/en/2/2e/Inception_%282010%29_theatrical_poster.jpg", // Inception
  },
  {
    id: 3,
    url: "https://upload.wikimedia.org/wikipedia/en/9/9f/Blade_Runner_%281982_poster%29.png", // Blade Runner 2049
  },
  {
    id: 4,
    url: "https://upload.wikimedia.org/wikipedia/en/d/db/The_Matrix.png", // The Matrix
  },
  {
    id: 5,
    url: "https://upload.wikimedia.org/wikipedia/en/d/df/Arrival%2C_Movie_Poster.jpg", // Arrival
  },
];

// Superhéroes
export const arrayThirdList = [
  {
    id: 1,
    url: "https://upload.wikimedia.org/wikipedia/en/3/30/Kick-Ass_film_poster.jpg", // Avengers: Endgame
  },
  {
    id: 2,
    url: "https://upload.wikimedia.org/wikipedia/en/1/1c/The_Dark_Knight_%282008_film%29.jpg", // The Dark Knight
  },
  {
    id: 3,
    url: "https://encrypted-tbn1.gstatic.com/images?q=tbn:ANd9GcQ-v3PuKTFaA3rhhgvwRDVyl2_nvDd2vHh3OUleNovii5pYTy3HOzIwIiXWc3pKOlkJaI39B5-zMcHVCdTC1X6ifa8MI4yzn1mxbZu1IIYCJw", // Spider-Man: No Way Home
  },
  {
    id: 4,
    url: "https://upload.wikimedia.org/wikipedia/en/d/d6/Black_Panther_%28film%29_poster.jpg", // Black Panther
  },
  {
    id: 5,
    url: "https://upload.wikimedia.org/wikipedia/en/b/b0/Wonder_Woman_%282017_film%29_poster.jpg", // Wonder Woman
  },
];
